import { Injectable } from '@angular/core';

@Injectable()
export class HtmlHelpersService {

  constructor() { }

  decodeHtmlEntity (str) {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value ;   
  }

  public removeHtmlTags(htmlContent):string{
    if(htmlContent){
      return htmlContent.replace(/<[^>]*>/g, '')
    }
    return '';
  }

}
